import * as Yup from 'yup'

import { FC, HTMLAttributes, useEffect } from "react"

import { FieldError } from '../../../../../widgets'
import { IEntity } from "../../../../../base/types"
import { ITextAreaProps } from './ITextAreaProps'
import clsx from 'clsx'
import { useFormContext } from "../../form"
import { useFormikContext } from "formik"
import { useTextAreaValidationSchema } from './TextAreaValidationSchema'

interface ITextAreaFieldProps extends HTMLAttributes<HTMLInputElement>, ITextAreaProps {
    name: string
}

export const TextAreaField: FC<ITextAreaFieldProps> = (props) => {
    const { id, name, placeholder, className, title, readOnly, disabled } = props;
    const schema = useTextAreaValidationSchema(props)
    const { getFieldProps, errors, touched } = useFormikContext<IEntity>() || {}
    const { updateSchema } = useFormContext()

    useEffect(() => {
        if (!name || !schema) return;

        const formSchema = Yup.object().shape({ [name]: schema });
        updateSchema(formSchema);

        // eslint-disable-next-line
    }, [name, schema])

    let fieldProps = name ? getFieldProps(`['${name}']`) : { value: '' }
    if (fieldProps.value === undefined)
        fieldProps = { ...fieldProps, value: '' }

    return <>
        <textarea
            id={id}
            title={title}
            {...fieldProps}
            className={clsx(className, "form-control form-control-sm")}
            placeholder={placeholder}
            readOnly={readOnly}
            disabled={disabled}
        />
        <FieldError show={touched[name] && !!errors[name]} message={`${errors[name]}`} />
    </>
}
